import { trustStats } from '@/mocks/categories';

export default function TrustBadges() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
            {trustStats.map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col items-center text-center p-5 md:p-6 bg-background-100 rounded-lg transition-all duration-300 hover:bg-primary-50 group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${stat.icon} text-xl`}></i>
                </div>
                <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 group-hover:text-primary-700 transition-colors duration-300">
                  {stat.value}
                </span>
                <span className="mt-1 text-xs md:text-sm text-foreground-600">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}